import axios from "../../public Func/axiosAuth";

const baseUrl = `${process.env.REACT_APP_BACKEND_URL}/voucher`;

const cleanPayload = (payload) => {
  const next = { ...payload };
  Object.keys(next).forEach((key) => {
    if (next[key] === undefined) {
      delete next[key];
    }
  });
  return next;
};

export const normalizeVoucher = (voucher = {}) => ({
  id: voucher.id,
  code: voucher.code,
  discountType: voucher.discountType,
  discountValue: voucher.discountValue,
  active: voucher.active,
  createdAt: voucher.createdAt,
  expired: voucher.expired,
  expiryDate: voucher.expiryDate,
  status: voucher.status,
  updatedAt: voucher.updatedAt,
});

export const listVouchers = async () => {
  const response = await axios.get(baseUrl);
  return response.data;
};

export const getVoucherById = async (voucherId) => {
  const response = await axios.get(baseUrl);
  return response.data.find((voucher) => voucher.id == voucherId);
};

export const getVoucherUsages = async (voucherId) => {
  const response = await axios.get(`${baseUrl}/${voucherId}/usages`);
  return response.data;
};

export const createVoucher = async (payload) => {
  const response = await axios.post(baseUrl, cleanPayload(payload));
  return normalizeVoucher(response.data);
};

export const updateVoucher = async (voucherId, payload) => {
  const response = await axios.put(
    `${baseUrl}/${voucherId}`,
    cleanPayload(payload),
  );
  return normalizeVoucher(response.data);
};

export const disableVoucher = async (voucherId) => {
  const response = await axios.post(`${baseUrl}/${voucherId}/disable`);
  return response.data;
};
